import { useState } from "react";
import { Link } from "react-router-dom";
import { Send, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ContactDialog } from "@/components/ContactDialog";

const TikTokIcon = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...props}><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" /></svg>
);

export function Footer() {
  const { site } = useAuth();
  const [contactOpen, setContactOpen] = useState(false);
  const tiktok = site?.tiktok || "@CorexeBest7";
  const telegram = site?.telegram || "@KimBuSAMET";

  return (
    <footer className="mt-20 border-t border-slate-800/80 bg-[#05070D]" id="hakkinda">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-3">Hakkında</p>
          <h3 className="font-display text-lg font-bold text-slate-50">{site?.site_title || "COREXE INFO PUGLIC"}</h3>
          <p className="text-sm text-slate-400 mt-3 leading-relaxed" data-testid="footer-about-text">{site?.about_text}</p>
        </div>
        <div>
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-3">Sosyal</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a data-testid="footer-tiktok-link" href={`https://www.tiktok.com/${tiktok}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-slate-300 hover:text-cyan-300 transition-colors">
                <TikTokIcon className="h-4 w-4" /> TikTok: {tiktok}
              </a>
            </li>
            <li>
              <a data-testid="footer-telegram-link" href={`https://t.me/${telegram.replace("@", "")}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-slate-300 hover:text-cyan-300 transition-colors">
                <Send className="h-4 w-4" /> Telegram: {telegram}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <p className="font-mono-cx text-[10px] uppercase tracking-[0.3em] text-cyan-400 mb-3">İletişim</p>
          <p className="text-sm text-slate-400 leading-relaxed">Bir sorun mu var? Direkt yöneticiye yaz, mesajın admin paneline düşer.</p>
          <button data-testid="footer-contact-admin-button" onClick={() => setContactOpen(true)} className="mt-4 h-10 px-4 rounded-xl cx-btn-primary text-sm inline-flex items-center gap-2">
            <Send className="h-4 w-4" /> Yöneticiye Yaz
          </button>
        </div>
      </div>
      <div className="border-t border-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-600">
          <span>© {new Date().getFullYear()} {site?.site_title || "COREXE"} — Tüm hakları saklıdır.</span>
          <Link to="/admin/login" data-testid="footer-admin-login-link" className="inline-flex items-center gap-1.5 hover:text-slate-300 transition-colors">
            <Lock className="h-3 w-3" /> Admin Girişi
          </Link>
        </div>
      </div>
      <ContactDialog open={contactOpen} onOpenChange={setContactOpen} />
    </footer>
  );
}
